var _animate, _animate2, _animate3, _animate4, _animate5, _animate6, _animate7, _animate8, _animate9, _animate10, _animate11, _animate12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoading = function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fontSize: 60,
    preserveAspectRatio: "xMidYMid",
    style: {
      margin: "auto",
      background: "#fff",
      display: "block",
      shapeRendering: "auto",
      animationPlayState: "running",
      animationDelay: "0s"
    },
    viewBox: "0 0 100 100"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    }
  }, _animate || (_animate = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.9166666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(30 50 50)"
  }, _animate2 || (_animate2 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.8333333333333334s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(60 50 50)"
  }, _animate3 || (_animate3 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.75s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(90 50 50)"
  }, _animate4 || (_animate4 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.6666666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(120 50 50)"
  }, _animate5 || (_animate5 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.5833333333333334s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(150 50 50)"
  }, _animate6 || (_animate6 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.5s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(180 50 50)"
  }, _animate7 || (_animate7 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.4166666666666667s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(210 50 50)"
  }, _animate8 || (_animate8 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.3333333333333333s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(240 50 50)"
  }, _animate9 || (_animate9 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.25s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(270 50 50)"
  }, _animate10 || (_animate10 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.16666666666666666s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(300 50 50)"
  }, _animate11 || (_animate11 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "-0.08333333333333333s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))), /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 12,
    x: 47,
    y: 24,
    fill: "currentColor",
    rx: 3,
    ry: 6,
    style: {
      animationPlayState: "running",
      animationDelay: "0s"
    },
    transform: "rotate(330 50 50)"
  }, _animate12 || (_animate12 = /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    begin: "0s",
    dur: "1s",
    keyTimes: "0;1",
    repeatCount: "indefinite",
    values: "1;0"
  }))));
};
export default SvgLoading;